// Global Guards
/* eslint-disable */

function getTokenStorageKey() {
  const hostname = window.location.hostname;
  return hostname === "localhost" || /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)
    ? "mitaCustomerToken"
    : hostname.split(".")[0];
}

// const beforeEach = (to, from, next) => {
//   var usertoken = JSON.stringify(window.localStorage.getItem("mitaCustomerToken"));
//   const authUser = JSON.parse(usertoken);
//   if (to.meta.requiresAuth) {
//     if (authUser) {
//       next();
//     } else {
//       let url = window.location.href;
//       if(url.includes('feedback/details')) {
//         var res = url.split("/");
//         var pos = res.indexOf('details');
//         var id = res[pos+1];
//         next({ name: "Login", query: { 'redirect': 'FeedbackDetails', 'id': id } });
//       } else {
//         next({ name: "Login" });
//       }
//     }
//   }
//   next();
// };

const beforeEach = (to, from, next) => {
  const storageKey = getTokenStorageKey();
  const userToken = localStorage.getItem(storageKey);
  const authUser = userToken ? userToken : null;

  if (to.meta.requiresAuth) {
    if (authUser) {
      next();
    } else {
      const url = window.location.href;
      if (url.includes("feedback/details")) {
        const res = url.split("/");
        const pos = res.indexOf("details");
        const id = res[pos + 1];
        next({ name: "Login", query: { redirect: "FeedbackDetails", id: id } });
      } else {
        next({ name: "Login" });
      }
    }
  } else {
    next();
  }
};

const login = (to, from, next) => {
  const storageKey = getTokenStorageKey();
  if (localStorage.getItem(storageKey)) {
    next({ name: "Home" });
  }
  next();
};

const afterEach = (to, from) => {
  // Put your guard actions here
};

export default {
  beforeEach,
  login,
  afterEach,
};
